import { useForm } from 'react-hook-form';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { FocusHighlightCard } from './FocusHighlightCard';
import { useSectionChiefResolver } from '../useSectionChiefResolver';
import type { SectionProps } from './types';

type OperationsFormValues = {
  sectionChiefName: string;
  sectionChiefContact: string;
  branchDirectorName: string;
  branchDirectorContact: string;
  divisionGroupSupervisorName: string;
  divisionGroupSupervisorContact: string;
};

export function CardOperations({
  row,
  upsertWala,
  canEditCards,
}: SectionProps) {
  const { sectionChief } = useSectionChiefResolver(row.original.workGroupId);

  const defaultValues: OperationsFormValues = {
    sectionChiefName:
      sectionChief?.personName ?? row.original.sectionChief ?? '',
    sectionChiefContact: '',
    branchDirectorName: row.original.branchDirector ?? '',
    branchDirectorContact: '',
    divisionGroupSupervisorName: row.original.divisionGroupSupervisor ?? '',
    divisionGroupSupervisorContact: '',
  };

  const { register, handleSubmit, reset } = useForm<OperationsFormValues>({
    defaultValues,
  });

  const onSubmit = handleSubmit((values) => {
    upsertWala(row, {
      sectionChief: values.sectionChiefName,
      branchDirector: values.branchDirectorName,
      divisionGroupSupervisor: values.divisionGroupSupervisorName,
    });
    (document.activeElement as HTMLElement | null)?.blur();
  });

  return (
    <FocusHighlightCard size="sm">
      <CardHeader>
        <CardTitle>
          4. Operations or Intelligence/Inspections Personnel
        </CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={onSubmit} className="tw:grid tw:gap-4">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Position</TableHead>
                <TableHead>Name</TableHead>
                {/* <TableHead>Contact Information</TableHead> */}
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell>Section Chief</TableCell>
                <TableCell>
                  <Input {...register('sectionChiefName')} readOnly disabled />
                </TableCell>
                {/* <TableCell>
                  <Input {...register('sectionChiefContact')} disabled />
                </TableCell> */}
              </TableRow>
              <TableRow>
                <TableCell>Branch Director</TableCell>
                <TableCell>
                  <Input {...register('branchDirectorName')} />
                </TableCell>
                {/* <TableCell>
                  <Input {...register('branchDirectorContact')} disabled />
                </TableCell> */}
              </TableRow>
              <TableRow>
                <TableCell>Division/Group Supervisor</TableCell>
                <TableCell>
                  <Input {...register('divisionGroupSupervisorName')} />
                </TableCell>
                {/* <TableCell>
                  <Input
                    {...register('divisionGroupSupervisorContact')}
                    disabled
                  />
                </TableCell> */}
              </TableRow>
            </TableBody>
          </Table>
          <div className="tw:invisible tw:flex tw:gap-2 tw:group-focus-within/card:visible">
            <Button type="submit" size="sm" disabled={!canEditCards}>
              Save
            </Button>
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={(event) => {
                reset(defaultValues);
                event.currentTarget.blur();
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </CardContent>
    </FocusHighlightCard>
  );
}
